/**
 * Drupal Services.
 * Custom checks for Drupal services.  Used to safely provide header and footer
 * to third party sites.
 *
 * @format
 */

/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable prefer-destructuring */
/* eslint-disable global-require */

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    drupalSettings: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Drupal: any;
  }
}

/**
 * Language Prefixes.
 */
export const languagePrefixes = [
  'de',
  'en-au',
  'en-ca',
  'en-ch',
  'en-gb',
  'es',
  'es-xl',
  'fi',
  'fr',
  'fr-ca',
  'nl',
  'ja',
  'pt-pt',
  'pt-br',
  'tr',
  'zh-hans',
  'zh-hant',
];

// Production
export const baseUrl = 'https://www.varian.com';
const baseApiUrl = `${baseUrl}`;

/**
 *  Safe Current Language.
 *
 * @returns
 */
export const safeCurrentLanguage = (): string => {
  return typeof window.drupalSettings?.path?.currentLanguage !== 'undefined'
    ? window.drupalSettings?.path?.currentLanguage
    : '';
};

/**
 * Safe Language Prefix.
 *
 * @returns
 */
export const safeLanguageUrlPrefix = (): string => {
  return typeof window.drupalSettings?.path?.pathPrefix !== 'undefined'
    ? window.drupalSettings?.path?.pathPrefix
    : '';
};

/**
 * Current Logged In.
 */
export const currentlyLoggedIn = (): boolean => {
  return window.drupalSettings.varian.loggedIn;
};

/**
 * Safe URL.
 */
export const safeUrl = (url?: string, apiEndpoint = false): string => {
  const safeBaseUrl = apiEndpoint ? baseApiUrl : baseUrl;
  if (typeof url === 'undefined') {
    return '#';
  }
  if (url.indexOf('http') > -1) {
    return url;
  }
  return typeof window.Drupal !== 'undefined' ? url : `${safeBaseUrl}${url}`;
};
